import { DeliveryMessageConfig, TimeFrameConfig } from './types'

const deliveryDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
]

export const getDeliveryMessage = (
  deliveryMessage: DeliveryMessageConfig,
  isSsr: boolean
) => {
  let deliveryInfoMessage =
    deliveryMessage?.enableDeliveryInfo &&
    deliveryMessage?.defaultDeliveryMessage

  if (!isSsr && deliveryMessage?.enableDeliveryInfo) {
    deliveryMessage?.timeFrames?.forEach((timeFrame: TimeFrameConfig) => {
      const [startHour, startMin] = (timeFrame.startTime || '').split(':')
      const [endHour, endMin] = (timeFrame.endTime || '').split(':')
      const timeFrameStartDay =
        deliveryDays.indexOf(timeFrame.startDate ?? '') + 1
      const timeFrameEndDay = deliveryDays.indexOf(timeFrame.endDate ?? '') + 1

      const currentDate = new Date()
      const day = currentDate.getDay()

      const startDate = new Date()
      startDate.setDate(startDate.getDate() + (timeFrameStartDay - day))
      startDate.setHours(Number(startHour))
      startDate.setMinutes(Number(startMin))

      const endDate = new Date()
      endDate.setDate(endDate.getDate() + (timeFrameEndDay - day))
      endDate.setHours(Number(endHour))
      endDate.setMinutes(Number(endMin))

      if (startDate.getTime() > endDate.getTime()) {
        endDate.setDate(endDate.getDate() + 7)
      }

      if (startDate <= currentDate && currentDate <= endDate) {
        deliveryInfoMessage = timeFrame.deliveryMessage
      }
    })
  }

  if (deliveryMessage?.enableDeliveryInfo && deliveryInfoMessage) {
    return {
      ...(deliveryMessage?.deliveryImageUrl
        ? {
            image: {
              src: deliveryMessage?.deliveryImageUrl,
              height: '48',
              width: '48'
            }
          }
        : {}),
      ...(deliveryInfoMessage
        ? {
            content: deliveryInfoMessage
          }
        : {})
    }
  }

  return null
}
